import './App.css';
import {Route, Routes} from 'react-router-dom';

import ProtectedRoute from './CommonComponents/ProtectedRoute/ProtectedRoute';
import AdminDashboardScreen from './ScreenComponents/AdminScreens/AdminDashboardScreen';
import AuthLayout from './ScreenComponents/AuthLayout/AuthLayout';

function App() {
  return (
    <div className={'text-center text-2xl font-semibold'}>
      <Routes>

        {/* Auth Routes */}
        <Route path={'/'} element={<AuthLayout />} />

        {/* <Route
          path={'/forgot-password'}
          element={<ResetPasswordComponent />}
        /> */}

        {/* ADMIN ROUTES */}
        <Route
          path={'/admin/*'}
          element={(
            <ProtectedRoute allowedRoles={['ADMIN']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

        {/* DOCTOR ROUTES */}
        <Route
          path={'/doctor/*'}
          element={(
            <ProtectedRoute allowedRoles={['DOCTOR']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

        {/* receptionist ROUTES */}
        <Route
          path={'/receptionist/*'}
          element={(
            <ProtectedRoute allowedRoles={['RECEPTIONIST']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

        {/* therapist ROUTES */}
        <Route
          path={'/therapist/*'}
          element={(
            <ProtectedRoute allowedRoles={['THERAPIST']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

        {/* pharmacist ROUTES */}
        <Route
          path={'/pharmacist/*'}
          element={(
            <ProtectedRoute allowedRoles={['PHARMACIST']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

        {/* accountant ROUTES */}
        <Route
          path={'/accountant/*'}
          element={(
            <ProtectedRoute allowedRoles={['ACCOUNTANT']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

        {/* patient ROUTES */}
        <Route
          path={'/patient/*'}
          element={(
            <ProtectedRoute allowedRoles={['PATIENT']}>
              <AdminDashboardScreen />
            </ProtectedRoute>
          )}
        />

      </Routes>
    </div>
  );
}

export default App;
